import React, { Component } from 'react';
import { Badge, Button } from '@mui/material';

// Badge Label is the Badge component from Material-UI.
// badgeStyle is required - Please add top, right, and backgroundColor. (You will also need to add color and fontWeight attribute as well)

class BadgeLabel extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const p = this.props;
    return (
      // <Badge
      //   badgeContent={this.props.badgeContent}
      //   className={p.className}
      // >
      //   <RaisedButton className={p.buttonClassName}
      //       label={p.label}
      //   style={p.style}
      //       disabled={p.disabled}
      //       primary={p.primary}
      //       onTouchTap={p.onTouchTap}
      //       href={p.href}
      //       target={p.target}
      //   download={p.download}
      //   labelStyle={p.labelStyle}
      //   buttonStyle={p.buttonStyle}>

      //       {p.children}
      //   </RaisedButton>
      // </Badge>
      <Badge
        badgeContent={p.badgeContent}
        className={p.className}
        overlap="circular"
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Button
          className={p.buttonClassName}
          id="SearchOnlineOrderBtn"
          variant={p.primary ? 'contained' : 'outlined'} // Primary button if p.primary is true
          style={p.style}
          disabled={p.disabled}
          onClick={p.onTouchTap} // Use onClick instead of onTouchTap
          href={p.href}
          target={p.target}
          download={p.download}
          sx={{ ...p.buttonStyle }} // Use sx for button styles
        >
          {p.label}
          {p.children}
        </Button>
      </Badge>
    );
  }
}

export default BadgeLabel;
